// extracted by mini-css-extract-plugin
export var assigneeBadge = "_l6-0";
export var assigneeDetails = "_l6-1";
export var assigneeInfo = "_l6-2";
export var dropdownContainer = "_l6-4";
export var dropdownImage = "_l6-5";
export var editAssigneeInfo = "_l6-3";
export var editAssigneeModalContainer = "_l6-6";
export var hidden = "_l6-8";
export var input = "_l6-7";